import { render, staticRenderFns } from "./GeneralSection.vue?vue&type=template&id=5b0987ea"
import script from "./GeneralSection.vue?vue&type=script&lang=js"
export * from "./GeneralSection.vue?vue&type=script&lang=js"
import style0 from "./GeneralSection.vue?vue&type=style&index=0&id=5b0987ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports